import { render, staticRenderFns } from "./torna-indietro.vue?vue&type=template&id=0f74e9e9&"
import script from "./torna-indietro.vue?vue&type=script&lang=js&"
export * from "./torna-indietro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports